var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack440({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.57,11.62V9.37A3,3,0,0,1,6,8.46,2.33,2.33,0,0,1,5.53,7,2.1,2.1,0,0,1,6.09,5.5a2.22,2.22,0,0,1,1.48-.69V4.27h.78v.54a2.27,2.27,0,0,1,1.36.58,2.26,2.26,0,0,1,.64,1.29L9,6.85A1.1,1.1,0,0,0,8.35,6v2.1A3.49,3.49,0,0,1,10.1,9a2.13,2.13,0,0,1,.47,1.42A2.39,2.39,0,0,1,10,12.06a2.56,2.56,0,0,1-1.63.82v1H7.57v-1a2.51,2.51,0,0,1-1.51-.7,2.76,2.76,0,0,1-.74-1.63l1.4-.16a1.82,1.82,0,0,0,.32.75A1.59,1.59,0,0,0,7.57,11.62ZM7.57,6a1,1,0,0,0-.51.36,1,1,0,0,0-.18.57.86.86,0,0,0,.17.53,1.15,1.15,0,0,0,.52.4Zm.78,5.71A1.07,1.07,0,0,0,9,11.32a1,1,0,0,0,.25-.7A1,1,0,0,0,9,10a1.28,1.28,0,0,0-.69-.4Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack440);
export default __webpack_public_path__ + "static/media/Symbolpack_4_40.36eaf47618d8bee73e2ddebed7259c9c.svg";
export { ForwardRef as ReactComponent };